import { memo } from "react";
import Icon from "./Icon";
import { cn } from "@/lib/utils";

export type StarRatingProps = {
  maxStars?: number;
  rating?: number;
  size?: "sm" | "md";
} & React.ComponentProps<"span">;

export const StarRating = ({
  maxStars = 5,
  rating = 5,
  className,
  size = "sm",
  ...rest
}: StarRatingProps) => {
  const fullStars = Math.floor(rating);
  const partialFill = rating - fullStars;

  return (
    <span
      className={cn(
        "flex gap-[1.67]",
        { "gap-[2.3]": size === "md" },
        className
      )}
      {...rest}
    >
      {Array.from({ length: maxStars }).map((_, index) => {
        const starNumber = index + 1;
        const isFull = starNumber <= fullStars;
        const isPartial = starNumber === fullStars + 1;

        return (
          <span
            key={index}
            className={cn(
              "relative size-5 flex items-center justify-center shrink-0 bg-[#dcdce6]",
              "before:absolute before:inset-y-0 before:left-0 before:h-full before:bg-[#00b67a]",
              {
                "before:w-full": isFull,
                "before:w-[var(--star-fill)]": isPartial,
                "size-[29.8]": size === "md",
              }
            )}
            style={
              isPartial
                ? ({
                    "--star-fill": `${Math.round(partialFill * 100)}%`,
                  } as React.CSSProperties)
                : undefined
            }
          >
            <Icon
              id="icon-star_14"
              width={14}
              height={14}
              className={cn("relative z-[1] w-3.5 h-3.5 shrink-0 text-white", {
                "size-5": size === "md",
              })}
            />
          </span>
        );
      })}
    </span>
  );
};

export default memo(StarRating);
